export const DEFAULT_FORM_DATA = {
  firstName: '',
  lastName: '',
  email: '',
  jobTitle: '',
  phoneNumber: '',
  companyName: '',
  webSite: '',
  addressLine1: '',
  addressLine2: '',
  photoURL: '',
  bannerURL1: '',
  bannerURL2: '',
  bannerURL3: '',
  fontName: '',
  colorOne: '',
  colorTwo: '',
  colorThree: '',
  facebookURL: '',
  twitterURL: '',
  linkedinURL: '',
  youtubeURL: '',
  githubURL: '',
};

export const DEFAULT_STYLE_VALUES = {
  fontName: 'Arial, sans-serif',
  colorOne: '#111827',
  colorTwo: '#4b5563',
  colorThree: '#e43349',
};

export const EXAMPLE_FORM_DATA = {
  ...DEFAULT_FORM_DATA,
  firstName: 'John',
  lastName: 'Doe',
  email: 'john.doe@example.com',
  jobTitle: 'Software Engineer',
  phoneNumber: '+1 (234) 567-890',
  companyName: 'Example Corp',
  webSite: 'https://www.example.com',
  addressLine1: '123 Main Street',
  addressLine2: 'New York, NY',
  photoURL: 'https://via.placeholder.com/96',
  bannerURL1: 'https://via.placeholder.com/560x90/f4f4f5/111827?text=Banner+1',
  bannerURL2: 'https://via.placeholder.com/560x90/e2e8f0/111827?text=Banner+2',
  bannerURL3: 'https://via.placeholder.com/560x90/fee2e2/7f1d1d?text=Banner+3',
  colorOne: '#111827',
  colorTwo: '#475569',
  colorThree: '#e43349',
  linkedinURL: 'https://www.linkedin.com',
  githubURL: 'https://github.com',
};
